import MoreButtonSVG from "../../../../SVGs/MoreButtonSVG";
import stl from "./List.module.css";
import Button from "@/components/UiKit/Button/Button";
import useHelpers from "@hooks/useHelpers";

const List = ({title, list, inLineButtonText, buttonText, buttonUrl, className = ""}) => {

    const {createUrl, navigateToHard} = useHelpers();
    return (
        <div className={`${stl.CL_container} ${className}`}>
            <h2>
                {title}
            </h2>
            <div className={stl.CL_list}>
                {list.map((city, idx) => {
                    return (
                        <a key={idx} href={createUrl(`/city/${city.seo_name}`)}>
                            <h3>{city.name}</h3>
                        </a>
                    );
                })}
                {inLineButtonText && <a href={createUrl(buttonUrl)}>
                    <h3>
                        {inLineButtonText}
                        <MoreButtonSVG/>
                    </h3>
                </a>}
            </div>
            {buttonText && <Button onClick={() => {
                navigateToHard(buttonUrl);
            }} className={stl.partnersButton}>
                {buttonText}
            </Button>}
        </div>
    );
};

export default List;
